const featureFlags = {
  // Update version
  forceUpdateVersion: '0.0.1',
  updateBanner: false,
  herbieDashboardVersion: '0.0.1',
  herbieDashboardVersionTest: '0.0.1',

  // Monitoring
  activityCompletionStatus: false,
  devicesPollingIntervalWithSse: 300000,
  devicesSlideSseTimeInMs: 10100,
  idleTime: true,
  libraryExtensionEventSource: false,
  maxElementsForAlertReport: 25000,
  removedDevice: false,
  routeMapMatching: false,
  showFleetPolicyPage: false,
  unconstrainPaginetaAutocomplete: false,
  showDeviceObservation: false,
  deviceSynchronizingStatusThreshold: 45,

  // Analytics
  fuelCardAlelo: false,
  fuelCardManual: false,
  fuelCardMaxifrota: false,
  fuelCardPrime: false,
  fuelCardSodexo: false,
  fuelCardTicketlog: false,
  showAdvancedAnalyticsPage: false,
  showIncidentsReport: false,
  useSpeedEventsMedianMetrics: false,
  coblinator: false,
  enableBrokenFuelCardIntegrationBanner: false,
  enableRiskEventsReport: false,
  safetyRanking: false,

  // Account Management
  driverIdentification: false,
  showCustomerSection: false,

  // Videos
  showMulticamLandingPage: false,
  enableFaceIdAssociation: false,
  livestream: false,
  disableWifiConfiguration: false,
  videoImpactEvent: false,

  // IoT
  enableImmobilizer: false,

  // Data Platform
  integrationsPage: false,

  // Tools
  ddRumSampleRate: 100,
  ddRumReplaySampleRate: 0,
  useDdRum: false,
  oneSignal: false,
  fuelTypeform: false,

  // Temporary
  showWarningBanner: false,

  // Home Banner
  showScheduleInstallDeviceBanner: false,
  useSpeedEventsOsmTestAB: false,
};

type FeatureFlags = typeof featureFlags;

export { featureFlags };
export default FeatureFlags;
